import angular from 'angular';
import CommissionModalService from './commissionModalService';

export default angular
  .module('commission.scenes.commissionManagement.services', [])
  .service('commissionModalService', CommissionModalService).name;
